import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, MapPin } from "lucide-react";
import ShareBar from "./ShareBar";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/5" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-heading text-3xl lg:text-4xl font-semibold text-white tracking-wide">
              CINEGÉTICA <span className="text-gold">RUTA DEL AGUA</span>
            </p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-sand">
              Club de Caza · Guillena (Sevilla)
            </p>
            <p className="mt-4 text-white/50 text-sm leading-relaxed max-w-sm font-light">
              Club de caza privado. Hermandad, experiencias y exclusividad en las
              mejores fincas de Guillena y de toda España.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="https://instagram.com/clubdecazacotoprivado" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-gold transition-colors duration-200" data-testid="footer-instagram" aria-label="Instagram">
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-gold transition-colors duration-200" data-testid="footer-facebook" aria-label="Facebook">
                <Facebook size={20} strokeWidth={1.5} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-gold transition-colors duration-200" data-testid="footer-youtube" aria-label="YouTube">
                <Youtube size={20} strokeWidth={1.5} />
              </a>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="overline-gold mb-5">Club</p>
            <ul className="space-y-3 text-sm text-white/60 font-light">
              <li><Link to="/sorteos-exclusivos" className="hover:text-gold transition-colors duration-200">Sorteos Exclusivos</Link></li>
              <li><Link to="/acciones-de-caza" className="hover:text-gold transition-colors duration-200">Acciones de Caza</Link></li>
              <li><Link to="/homologa-tu-trofeo" className="hover:text-gold transition-colors duration-200">Homologa Tu Trofeo</Link></li>
              <li><Link to="/video-club" className="hover:text-gold transition-colors duration-200">Video Club</Link></li>
              <li><Link to="/fincas" className="hover:text-gold transition-colors duration-200">Nuestras Fincas</Link></li>
              <li><Link to="/modalidades" className="hover:text-gold transition-colors duration-200">Modalidades de Caza</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="overline-gold mb-5">Contacto</p>
            <ul className="space-y-3 text-sm text-white/60 font-light">
              <li className="flex items-center gap-3">
                <Mail size={16} strokeWidth={1.5} className="text-gold" />
                <a href="mailto:azambranocomercial@gmail.com" className="hover:text-gold transition-colors duration-200" data-testid="footer-email">
                  azambranocomercial@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} strokeWidth={1.5} className="text-gold" />
                <span>Guillena (Sevilla) · España</span>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <span className="text-gold text-xs uppercase tracking-[0.15em]">Antonio</span>
                <a href="tel:+34678783000" className="hover:text-gold transition-colors duration-200" data-testid="footer-phone-antonio">678 783 000</a>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <span className="text-gold text-xs uppercase tracking-[0.15em]">Javier</span>
                <a href="tel:+34664069630" className="hover:text-gold transition-colors duration-200" data-testid="footer-phone-javier">664 069 630</a>
              </li>
              <li><Link to="/tienda" className="hover:text-gold transition-colors duration-200">Tienda del Club</Link></li>
              <li><Link to="/hazte-socio" className="hover:text-gold transition-colors duration-200">Hazte Socio — 100€/año</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30 tracking-wide" data-testid="footer-copyright">
            © {new Date().getFullYear()} Cinegética Ruta del Agua de Guillena. Todos los derechos reservados.
          </p>
          <ShareBar />
        </div>
      </div>
    </footer>
  );
}
